<aside [tuiNavigationAside]="isSidebarCollapsed()">

  @for (route of sideBarLinks; track $index) {
    <!--    <ng-container *access="route.roles">-->
    @if (route.children?.length) {
      <tui-aside-group>
        <button iconStart="@tui.{{route.icon}}" tuiAsideItem tuiChevron>
          {{ route.label }}
          <ng-template>
            @for (child of route.children; track $index) {
              <!--                <ng-container *access="child.roles">-->
              <a tuiAsideItem [routerLink]="child.link"
                 (click)="$event.preventDefault(); $event.stopPropagation()">{{ child.label }}</a>
              <!--                </ng-container>-->
            }
          </ng-template>
        </button>
      </tui-aside-group>
    } @else {
      <a iconStart="@tui.{{route.icon}}" tuiAsideItem [routerLink]="route.link">{{ route.label }}</a>
    }
    <!--    </ng-container>-->
  }
  <footer>
    <button tuiAsideItem type="button" [iconStart]="isSidebarCollapsed() ? '@tui.chevron-left' : '@tui.chevron-right'"
            (click)="toggleSidebar()">
      {{ isSidebarCollapsed() ? 'Collapse' : 'Expand' }}
    </button>
  </footer>
</aside>



